import Breadcrumb from "@/components/feature/Breadcrumb";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";
import { site } from "@/config/site";

export default function Faq() {
  usePageMeta(
    "常见问题 - 火影同人动漫",
    "火影同人动漫常见问题解答：分类方式、更新节奏、作品状态、评分热度等疑问一站式解答。",
  );

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    inLanguage: "zh-CN",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <section className="relative overflow-hidden bg-background-100">
        <div className="container-x py-12 md:py-16">
          <Breadcrumb crumbs={[{ label: "常见问题" }]} />
          <div className="mt-8 max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-800">
              <i className="ri-question-line" />
              追更答疑
            </span>
            <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              常见问题
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于火影同人动漫的分类方式、更新节奏、作品状态与评分规则，这里为你一一解答。若仍有疑问，欢迎联系我们。
            </p>
          </div>
        </div>
      </section>

      <section className="container-x py-12 md:py-16">
        <div className="mx-auto max-w-3xl">
          <FaqAccordion />
        </div>
      </section>

      <section className="border-t border-background-200 bg-background-100 py-12">
        <div className="container-x text-center">
          <h2 className="font-heading text-xl font-black text-foreground-950">还有问题没解答？</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            随时通过邮箱联系我们，我们会尽快回复你的疑问。
          </p>
          <p className="mt-4 inline-flex items-center gap-2 text-sm text-foreground-700">
            <i className="ri-mail-line text-primary-600" />
            {site.email}
          </p>
        </div>
      </section>
    </>
  );
}